import { signOut } from 'firebase/auth';
import type { QueryClient } from '@tanstack/react-query';
import { auth } from './firebase';

// ─── Una sesión no le deja nada a la siguiente ──────────────────────────────
// En un computador compartido, quien entra después en la MISMA pestaña no debe
// ver nada de quien salió. Antes, cerrar sesión navegaba a /login sin recargar:
// la caché de consultas (react-query) seguía en memoria, con claves por
// seminario y por pantalla pero NO por usuario. Otra persona del mismo seminario
// que abría la misma pantalla recibía esos datos —en los primeros 30 s sin
// siquiera consultar— hasta que el servidor la rechazaba. Y heredaba la página
// en la que había quedado la anterior. (S0, PM 2026-10-24.)
//
// Dos defensas, a propósito redundantes:
//  1. TODO cierre de sesión recarga la página: la memoria entera (caché,
//     stores, listeners) se va con ella, y la siguiente persona entra por
//     /login a SU inicio.
//  2. Ante CUALQUIER cambio de usuario —también uno que no pasó por el botón,
//     como un token vencido o una sesión cerrada en otra pestaña— el
//     AuthProvider vacía la caché antes de que nadie la lea.

/** ¿Cambió la persona? `undefined` = todavía no hubo un primer evento de
 *  autenticación: la caché está vacía y vaciarla cortaría consultas públicas
 *  en curso (la resolución del dominio). */
export function userChanged(previous: string | null | undefined, next: string | null): boolean {
  return previous !== undefined && previous !== next;
}

/** Vacía la caché si cambió la persona. Devuelve el uid a recordar. */
export function applyUserChange(
  queryClient: QueryClient,
  previous: string | null | undefined,
  next: string | null,
): string | null {
  if (userChanged(previous, next)) queryClient.clear();
  return next;
}

/** El ÚNICO cierre de sesión de la web: sale y recarga en `to` (por defecto
 *  /login). Un test rechaza cualquier otro `signOut(` en el código. */
export async function signOutAndReload(to = '/login'): Promise<void> {
  try {
    await signOut(auth);
  } finally {
    window.location.replace(to);
  }
}
